export const ANALYTICS_ROUTES = {
	analytics: "/app/analytics",
} as const;
